import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CTASection from "@/components/CTASection";
import SEO from "@/components/SEO";

export default function CaseStudies() {
  const [cases, setCases] = useState([]);
  useEffect(() => {
    api.get("/case-studies").then((r) => setCases(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="case-studies-page">
      <SEO title="Case Studies" description="Real work, real outcomes. A collection of the businesses we've had the pleasure of working with." />
      <section className="pt-16 pb-16 lg:pt-24">
        <div className="ob-container">
          <h1 className="ob-h1 max-w-5xl">A collection of work we've loved creating.</h1>
          <p className="ob-lead mt-8 max-w-3xl">
            Here's a look at some of the businesses we've had the pleasure of working with, and the work we did together.
          </p>
        </div>
      </section>

      <section className="pb-32">
        <div className="ob-container">
          <div className="grid md:grid-cols-2 gap-10 lg:gap-12">
            {cases.map((cs, idx) => (
              <article
                key={cs.slug}
                data-testid={`case-${cs.slug}`}
                className={`${idx % 2 === 1 ? "md:mt-16" : ""}`}
              >
                <div className="mb-6 aspect-[4/3] rounded-3xl overflow-hidden">
                  {cs.video ? (
                    <video
                      src={cs.video}
                      poster={cs.image}
                      autoPlay
                      muted
                      loop
                      playsInline
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <img
                      src={cs.image}
                      alt={cs.client}
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
                <div className="ob-eyebrow mb-2">{cs.industry}</div>
                <h3 className="ob-h3">{cs.heading || cs.client}</h3>
                <p className="ob-body mt-3 max-w-lg">{cs.challenge}</p>

                {cs.results?.length > 0 && (
                  <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-lg">
                    {cs.results.map((r, i) => (
                      <div key={i}>
                        <div className="text-[26px] font-light leading-none" style={{ color: "var(--ob-ink)" }}>{r.metric}</div>
                        <div className="text-[12px] mt-2" style={{ color: "var(--ob-muted)" }}>{r.label}</div>
                      </div>
                    ))}
                  </div>
                )}

                {cs.testimonial && (
                  <figure className="mt-6 pt-6 border-t border-[var(--ob-border)] max-w-lg">
                    <blockquote className="text-[17px] leading-[1.45] font-light" style={{ color: "var(--ob-ink)" }}>
                      &ldquo;{cs.testimonial.quote}&rdquo;
                    </blockquote>
                    {cs.testimonial.author && (
                      <figcaption className="mt-3 text-[13px]" style={{ color: "var(--ob-muted)" }}>
                        <span style={{ color: "var(--ob-ink)" }}>{cs.testimonial.author}</span>
                      </figcaption>
                    )}
                  </figure>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
